/* src/app/core/modules/shared/components/empty-placeholder-card/empty-placeholder-card.component.scss */
/*# sourceMappingURL=/avvera/dev/empty-placeholder-card.component.css.map */
